// extracted by mini-css-extract-plugin
export default {"cursorDot":"CustomCursor_cursorDot__bhjjL","cursorRing":"CustomCursor_cursorRing__vGDKD","hovering":"CustomCursor_hovering__joiWB"};